import {
  getMaxDaysBeforeSwitchToRed,
  getMaxStatusDays,
} from "../tools/ConfigurationReader";

export default () => {
  return {
    translation: {
      date: {
        long: "DD.MM.YYYY HH:mm:ss",
        short: "dd.MM.yyyy",
        shortDayJS: "DD.MM.YYYY",
        technicalDate: "yyyy-MM-dd",
        technicalDatetime: "yyyy-MM-dd HH:mm:ss",
        apiFormat: "YYYY-MM-DD_HH-mm-ss",
      },
      ui: {
        rotateLabel: "Drehen",
        history: "Historie",
        marketProperties: "Eigenschaften",
        toReview: "Zu überprüfen",
        toBeReviewedSoon: "Bald zu überprüfen",
        okay: "In Ordnung",
        logout: "Ausloggen",
        close: "Schließen",
        save: "Speichern",
        delete: "Löschen",
        changeShelfLife: "MHD im Regal geprüft",
        changeShelfLifeMessage:
          "Haben Sie das Regal vollumfänglich und tatsächlich geprüft?",
        date: "Datum",
        user: "Benutzer",
        status: "Status",
        marketComponentName: "Name",
        historyDialogMarketHeading: "Historie eines Marktes",
        historyDialogMarketComponentHeading: "Historie einer Markt Komponente",
        no: "Nein",
        yes: "Ja",
        goToHistory: "Zur Historie",
        placeholderForEmail: "Email",
        placeholderForPassword: "Passwort",
        login: "Anmelden",
        noMarketAvailable: "Kein Markt",
        categoryLabel: "Kategorie",
        statusLabel: "Status",
        number: "Nummer",
        criticalDate: "Kritischstes MHD",
        redRackButton: "Nächste Prüfung",
        noRackForValidation: "Alle Regale sind bereits überprüft!",
        objectSelection: "Objektauswahl",
        marketSelection: "Marktauswahl",
        newMarketComponent: "Objekt",
        newMarketComponentDescription: "Objekt",
        placeholderForMarketComponentShortDescription: "Kurzbezeichnung",
        marketComponentNumberLabel: "Regalnummer",
        shortDescriptionLabel: "Kurzbezeichnung",
        articleTypeLabel: "Sortiment",
        switchToYellowAfterXDays: "Wechsel zu Gelb nach X Tagen",
        switchToRedAfterXDays: "Wechsel zu Rot nach X Tagen",
        switchToRedAfterDate: "Kritischstes MHD eintragen?",
        daysBeforeSwitchToRed: "Tage vor kritischstem MHD",
        switchToRedAfterDatePlaceholder: "Datum auswählen",
        noImageFound: "Kein Bild gefunden",
        marketNameLabel: "Markt Name",
        marketStreetLabel: "Straße",
        marketHouseNumberLabel: "Hausnummer",
        marketZipLabel: "PLZ",
        marketCityLabel: "Ort",
        marketDistrictLabel: "Bezirk",
        marketAreaXLabel: "Länge (X)",
        marketAreaYLabel: "Breite (Y)",
        marketEnableMarketDrawing: "Aktivieren der Markt-Zeichnung",
        marketEnableMarketDrawingToggleEnable: "Aktiviert",
        marketEnableMarketDrawingToggleDisable: "Deaktiviert",
        upload: "Hochladen",
        altLogo: "Regalmonitor",
        versionString: "Version:",
        versionDelimiter: "#",
        altBackground: "Hintergrund",
        reduceArticleNow: "Es ist besser den Artikel direkt zu reduzieren",
        lastValidationDate: "Letzte Überprüfung am",
        tryAgain: "Erneut versuchen",
        versionChanges:
          "Es gab ein Update der Applikation, deshalb werden Sie in den nächsten Sekunden abgemeldet",
        adminLogout:
          "Der Admin hat eine Abmeldung für das komplette System erzwungen, in ein paar Sekunden werden Sie automatisch abgemeldet",
        administration: "Administration",
        userManagement: "Benutzerverwaltung",
        marketManagement: "Marktverwaltung",
        reporting: "Berichtswesen",
        userLogoutButton: "Alle abmelden",
        userLogoutMessage:
          "Sind Sie sicher, dass Sie alle Benutzer, die am System angemeldet sind, abmelden möchten?",
        page: "Seite",
        next: "weiter",
        previous: "zurück",
        selectDate: "Datum wählen",
        userCreate: "Benutzer erstellen",
        userEdit: "Benutzer bearbeiten",
        password: "Passwort",
        repeatPassword: "Passwort wiederholen",
        role: "Rolle",
        noOptionsMessage: "Keine Optionen",
        userMarketDialogHeader: "Markt-Freigabe für Benutzer",
        select: "Auswählen...",
        userResetPasswordDialogHeader: "Benutzerpasswort zurücksetzen",
        markets: "Märkte",
        reportMarketComponentHistory: "Gesamt-Historie Märkte",
        reportMarketComponent_30_60_90_Verification:
          "Markt-Komponenten Prüfstatus",
        reportMarketComponentWithoutCriticalBBD:
          "Markt-Komponenten kein kritisches MHD",
        reportMarketComponentWhereShortDescriptionNotEqualsNumber:
          "Markt-Komponenten Kurzbezeichnung ungleich Nummer",
        reportUser: "Mitarbeiter Highscore",
      },
      table: {
        general: {
          contains: "Enthält",
          notContains: "Enthält nicht",
          equals: "Gleich",
          notEqual: "Ungleich",
          startsWith: "Beginnt mit",
          endsWith: "Endet mit",
          blank: "Leer",
          notBlank: "Nicht leer",
          andCondition: "UND",
          orCondition: "ODER",
          filterOoo: "Filter...",
          actions: "Aktionen",
          firstPage: "Erste Seite",
          lastPage: "Letzte Seite",
          prevPage: "Vorherige Seite",
          nextPage: "Nächste Seite",
          page: "Seite",
          csvExport: "Kompletten Report als CSV exportieren",
        },
        userManagement: {
          username: "Benutzername",
          firstname: "Vorname",
          lastname: "Nachname",
          languageCode: "Sprachkürzel",
          email: "E-Mail",
          deactivated: "Deaktiviert",
          deactivatedBy: "Deaktiviert Von",
          addUser: "Benutzer hinzufügen",
          deactivateSelected: "Ausgewählte deaktivieren",
          activateSelected: "Ausgewählte aktivieren",
          edit: "Bearbeiten",
          deactivate: "Deaktivieren",
          activate: "Aktivieren",
          selectMarkets: "Märkte auswählen",
          resetPassword: "Passwort zurücksetzen",
          markets: "Märkte",
        },
        reportMarketComponentHistory: {
          market: "Markt",
          marketComponentName: "Regal Name",
          marketComponentNumber: "Regal Nummer",
          date: "Datum",
          username: "Benutzername",
          status: "Status",
          criticalDate: "Kritisches MHD",
        },
        reportMarketComponent: {
          shortDescription: "Kurzbezeichnung",
          description: "Bezeichnung",
          articleType: "Sortiment",
          type: "Typ",
          marketName: "Marktname",
          number: "Nummer",
          lastValidation: "Letzte Überprüfung",
          created: "Erstellt am",
        },
        reportUser: {
          username: "Benutzername",
          firstname: "Vorname",
          lastname: "Nachname",
          checkCount: "Anzahl der Prüfungen",
          deactivated: "Deaktiviert",
          deactivatedBy: "Deaktiviert Von",
        },
      },
      error: {
        baseUrlNotSet:
          "Die Base URL ist in den Umgebungsvariablen nicht definiert",
        invalidTokenResponse:
          "Die Authentifizierung kann nicht erfolgreich durchgeführt werden. Bitte versuchen Sie es später erneut",
        invalidUserProfileResponse:
          "Das Benutzer Profil konnte nicht geladen werden. Bitte versuchen Sie es später erneut",
        invalidValueForRotate:
          "Der eingegebene Wert must zwischen 0 und 359 liegen",
        invalidValueForSwitchToYellowAfterXDays: `Der eingegebene Wert must zwischen 1 und ${getMaxStatusDays()} liegen`,
        invalidValueForSwitchToRedAfterXDays: `Der eingegebene Wert must zwischen 1 und ${getMaxStatusDays()} liegen`,
        invalidValueForSwitchToRedAfterDate:
          "Der eingegebene Wert ist zu weit in der Zukunft",
        invalidValueForDaysBeforeSwitchToRed: `Der eingegebene Wert must zwischen 1 und ${getMaxDaysBeforeSwitchToRed()} liegen`,
        failedToFetchImage: "Bild konnte nicht geladen werden",
        webSocketNotConnected:
          "WebSocket nicht verbunden; die Markt Komponenten Synchronisation ist temporär deaktiviert",
        errorPageHeading: "Etwas ging schief!",
        errorPageContent:
          "Keine Panik!<br/>Sollte das Problem weiterhin bestehen, dann kontaktieren Sie bitte Ihren Systemadministrator oder Ihren Vorgesetzten.<br/>Dieser kann Ihnen weiterhelfen!",
        errorInvalidReport: "Ungültiger Report ausgewählt",
        unknownError: "Unbekannter Fehler",
        unknownReportingType: "Unbekannter Berichtswesen Typ",
      },
      success: {
        marketComponentDeleted:
          "Die Markt Komponente wurde erfolgreich gelöscht",
        marketComponentsSaved:
          "Die Markt Komponenten wurden erfolgreich aktualisiert",
        webSocketConnected:
          "WebSocket verbunden; die Markt Komponenten Synchronisation ist aktiviert",
        userSaved: "Der Benutzer wurde erfolgreich gespeichert",
        csvExportDownloaded: "Der CSV Export wurde heruntergeladen",
      },
      apiStatus: {
        GREEN: "Grün",
        GREENCYAN: "Grün",
        YELLOW: "Gelb",
        RED: "Rot",
        WHITE: "Nicht geprüft",
        UNKNOWN: "Unbekannt",
      },
      apiSuccess: {
        MARKET_COMPONENT_STATUS_UPDATED:
          "Markt Komponente Status wurde aktualisiert",
        MARKET_COMPONENT_DELETED: "Markt Komponente wurde erfolgreich gelöscht",
        NO_EXPIRED_MARKET_COMPONENTS_AVAILABLE_FOR_MARKET_ID:
          "Kein Markt Komponente ist abgelaufen",
        FILE_UPLOADED: "Datei wurde hochgeladen",
        LOGGING_SUCCESSFUL: "Das Logging war erfolgreich",
        AUTO_LOGOUT_SENT:
          "Auto-Logout wurde versendet. In den nächsten Sekunden werden alle angemeldeten Benutzer vom System abgemeldet",
        USER_STATUS_UPDATED:
          "Der Benutzer-Status wurde erfolgreich aktualisiert",
        PASSWORD_RESET: "Passwort erfolgreich zurückgesetzt",
      },
      apiError: {
        INVALID_CREDENTIALS: "Ungültige Anmeldeinformationen",
        INSUFFICIENT_PERMISSIONS: "Ungenügende Berechtigung",
        INVALID_ARGUMENT_EXPECTED_SIZE: "Fehlender Parameter 'Size'",
        INVALID_ARGUMENT_EXPECTED_POSITION: "Fehlender Parameter 'Position'",
        INVALID_ARGUMENT_EXPECTED_MARKET_CONFIGURATION:
          "Fehlender Parameter 'Market Configuration'",
        INVALID_JSON: "Ungültiges JSON Format",
        INVALID_MARKET_ID: "Ungültige Markt ID",
        NO_MARKET_COMPONENTS_AVAILABLE_FOR_MARKET_ID:
          "Keine Markt-Komponenten für die angegebene Markt ID verfügbar",
        UNSUPPORTED_HTTP_METHOD: "Nicht unterstützte HTTP Methode",
        UNSUPPORTED_URI: "Nicht unterstützter URI",
        INVALID_MARKET_COMPONENT_ID: "Ungültige Markt-Komponenten ID",
        INVALID_MARKET_COMPONENT_TYPE_ID: "Ungültige Markt-Komponenten-Typ ID",
        INVALID_MARKET_COMPONENT_ARTICLE_TYPE_ID:
          "Ungültige Markt-Komponenten-Artikel-Typ ID",
        TEXT_LENGTH_FOR_SHORT_DESCRIPTION_TOO_LONG:
          "Der Text für die Kurz-Beschreibung ist zu lange",
        INVALID_CHANGE_DATE_SET: "Ungültigen Status-Wechsel-Datum",
        INVALID_CHANGE_DATE_SET_FOR_USER:
          "Es ist besser den Artikel zu reduzieren",
        USER_IDENTIFIER_MUST_NOT_BE_EMPTY:
          "Die Benutzeridentifikation darf nicht leer sein",
        STATUS_YELLOW_DAYS_CANNOT_LARGER_THAN_RED_DAYS:
          "Die eingegebenen Tage für den gelben Status dürfen nicht größer sein als die für den roten Status",
        FILE_NOT_FOUND: "Datei wurde nicht gefunden",
        INVALID_MIME_TYPE: "Ungültiger Mimetype",
        INVALID_FILE_TARGET: "Ungültige Speicherziel",
        INVALID_ENTITY_ID_FOR_FILE_TARGET:
          "Ungültige Entitäten-ID für das Speicherziel",
        INVALID_FILE_CONTENT: "Ungültiger Datei-Inhalt",
        CANNOT_CREATE_TARGET_FOLDER:
          "Speicherziel konnte nicht erstellt werden",
        FILE_CANNOT_BE_MOVED: "Die Datei kann nicht verschoben werden",
        FILE_CANNOT_BE_REPLACED: "Die Datei kann nicht ersetzt werden",
        ERROR_PAGE_CONTENT:
          "Kein Panik! Wenn das Problem weiterhin besteht, dann kontaktieren Sie bitte Ihren System-Administrator. Dieser kann Ihnen weiterhelfen!",
        INVALID_JWT: "Ungültiger JWT",
        INVALID_ROLES: "Ungültige Rollen",
        INVALID_PERMISSIONS: "Ungültige Berechtigungen",
        INVALID_LANGUAGE_CODE: "Ungültiges Sprachkürzel",
        INVALID_EMAIL_FORMAT: "Ungültiges E-Mail-Format",
        EMPTY_PASSWORD_NOT_ALLOWED: "Das Passwort darf nicht leer sein",
        EMPTY_USERNAME_NOT_ALLOWED: "Der Benutzername darf nicht leer sein",
        EMPTY_FIRSTNAME_NOT_ALLOWED: "Der Vorname darf nicht leer sein",
        EMPTY_LASTNAME_NOT_ALLOWED: "Der Nachname darf nicht leer sein",
        INVALID_USER_SELECTED: "Ungültiger Benutzer ausgewählt",
        ACCOUNT_DEACTIVATED:
          "Das angegebene Konto ist deaktiviert, kontaktieren Sie Ihren Admin",
        INVALID_REPORT_SELECTED: "Ungültiger Report ausgewählt",
      },
      apiCategory: {
        CHECKOUT: "Kasse",
        COOLING: "Kühlung",
        DRINKS: "Getränke",
        DRY_GOODS_ASSORTMENT: "Trockensortiment",
        FRUIT_VEGETABLE: "Früchte / Gemüse",
        HIGH_RACK: "Hochregal",
        OTHERS: "Sonstiges",
        STANDEE: "Aufsteller",
        WAREHOUSE: "Lager",
      },
    },
  };
};
